import { Button } from "@mui/material"
import { Flex } from "components/common"

export type RequestLeaveReviewType = "approve" | "reject"

type Props = {
  disabled?: boolean
  onReview: (type: RequestLeaveReviewType) => void
}

const RequestLeaveReviewButtons = ({ disabled = false, onReview }: Props) => {
  return (
    <Flex gap={1} justifyContent="flex-end">
      <Button color="success" disabled={disabled} onClick={() => onReview("approve")} size="small" variant="outlined">
        Phê duyệt
      </Button>
      <Button color="error" disabled={disabled} onClick={() => onReview("reject")} size="small" variant="outlined">
        Từ chối
      </Button>
    </Flex>
  )
}

export default RequestLeaveReviewButtons
